import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { formatCurrency } from '@/lib/utils';
import { DEFAULT_PIPELINE_STAGES } from '@trinco/shared';

interface FunnelStage {
  name: string;
  slug: string;
  color: string;
  dealCount: number;
  weightedValue: number;
}

export function PipelineFunnel() {
  // Placeholder - will be wired to trpc.dashboard.pipelineFunnel
  const stages: FunnelStage[] = DEFAULT_PIPELINE_STAGES.filter(
    (s) => !s.isLost,
  ).map((s) => ({
    name: s.name,
    slug: s.slug,
    color: s.color ?? '#6B7280',
    dealCount: 0,
    weightedValue: 0,
  }));

  const maxValue = Math.max(...stages.map((s) => s.weightedValue), 1);

  return (
    <Card>
      <CardHeader>
        <CardTitle>Pipeline Funnel</CardTitle>
      </CardHeader>
      <CardContent>
        {stages.every((s) => s.dealCount === 0) ? (
          <div className="flex h-[300px] items-center justify-center text-sm text-muted-foreground">
            No deals in the pipeline yet.
          </div>
        ) : (
          <div className="space-y-3">
            {stages.map((stage) => {
              const widthPercent = maxValue > 0
                ? Math.max((stage.weightedValue / maxValue) * 100, 8)
                : 8;

              return (
                <div key={stage.slug} className="space-y-1">
                  <div className="flex items-center justify-between text-sm">
                    <span className="font-medium">{stage.name}</span>
                    <span className="text-muted-foreground">
                      {stage.dealCount} deals &middot;{' '}
                      {formatCurrency(stage.weightedValue, 'CAD')}
                    </span>
                  </div>
                  <div className="h-8 rounded-md bg-muted overflow-hidden">
                    <div
                      className="h-full rounded-md transition-all duration-500"
                      style={{
                        width: `${widthPercent}%`,
                        backgroundColor: stage.color,
                        opacity: 0.8,
                      }}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
